
    <div class="explorer-demo-container" style="height: 100% !important;">
<!-- Loading State with Shimmer -->
@if (isLoading()) {
  <!-- <app-document-loader
    message="Loading document editor..."
    [variant]="ShimmerVariant.TextBlock"
    [lineCount]="10"
    loaderId="collabora-loader"
  /> -->
      <div class="loader-overlay">
      <optima-progress-indicator
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { width: '100%', height: '100%' }
        ] } }">
      </optima-progress-indicator>
    </div>
}

<!-- Saving State with Shimmer Overlay -->
@if (isSaving()) {
  <div class="save-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 1000; background: rgba(255, 255, 255, 0.9); display: flex; align-items: center; justify-content: center;">
    <div style="text-align: center;">
      <div style="width: 200px; height: 100px;"></div>
      <p style="color: #666; font-size: 14px; margin: 0;">Saving document...</p>
    </div>
  </div>
}

<!-- Error State -->
@if (hasError()) {
  <div class="error show">
    <div class="error-icon">⚠️</div>
    <h2>Failed to Load Document</h2>
    <p class="error-message">{{ error() }}</p>
    <button class="retry-btn" (click)="retryLoad()">Retry</button>
  </div>
}

<!-- Collabora Editor Iframe -->
@if (iframeUrl() && !isLoading()) {
  <iframe 
    #collaboraIframe
    width="100%"
    height="100%"
    id="collabora-frame"
    [src]="iframeUrl()!"
    (load)="onIframeLoad()"
    (error)="onIframeError($event)"
    allow="clipboard-read; clipboard-write; autoplay"
    allowfullscreen>
  </iframe>
}

<!-- Debug Info (Press D key to toggle) -->
@if (debugVisible()) {
  <div class="debug-info show">
    <strong>Debug Info:</strong><br>
    <span [innerHTML]="debugText()"></span>
  </div>
}
    </div>